import {Component, computed, input} from '@angular/core';
import {NgClass} from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {HrToolAiCapabilityType} from '@frontend/shared-api';
import {DirectusTooltipComponent} from '../directus-tooltip/directus-tooltip.component';
import {HR_TOOL_AI_CAPABILITY_PRESENTATION} from '../../constants/hr-tool-ai-capability.constants';

@Component({
  selector: 'app-ai-capability-label',
  imports: [NgClass, TranslocoPipe, DirectusTooltipComponent],
  templateUrl: './ai-capability-label.component.html',
  host: {class: 'flex min-w-0 items-center gap-2'},
})
export class AiCapabilityLabelComponent {
  readonly capability = input.required<HrToolAiCapabilityType>();
  readonly withTooltip = input(true);

  protected readonly iconClass = computed(() => {
    const presentation = HR_TOOL_AI_CAPABILITY_PRESENTATION[this.capability()];
    return `${presentation.icon} ${presentation.colorClass}`;
  });
  protected readonly labelKey = computed(() => `hrTool.aiCapability.${this.capability()}.label`);
  protected readonly tooltipKey = computed(
    () => `hrTool.aiCapability.${this.capability()}.tooltip`,
  );
}
